import { Dictionary } from "@/lib/Dictionary.type";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";

import ShippingManifest from "./shipping-manifest.model";

export default class ShippingManifestRepository extends BasicRepository<ShippingManifest> {
  private readonly fShipRequestScope = "all-unshipped";

  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<ShippingManifest>,
    responseParser: ApiCollectionResponseParserService<ShippingManifest>
  ) {
    super("shipping_manifests", api, objectBuilder, responseParser);
  }

  public async shipRequest(factoryId: string): Promise<void> {
    await this.api.post(`${this.resourceName}/ship_requests`, {
      factoryId,
      scope: this.fShipRequestScope,
    });
  }

  protected prepareData(
    item: ShippingManifest
  ): Dictionary<string | number | string[]> {
    const data: Dictionary<string | number | string[]> = {
      id: item.id,
      factoryId: item.factory,
      trackingNumber: item.trackingNumber,
      bulkShipmentIds: item.bulkShipmentIds,
    };

    if (item.notes) {
      data.notes = item.notes;
    }

    if (item.carrier) {
      data.carrier = item.carrier;
    }

    return data;
  }
}
